window.Vue = require('vue').default;
import VTooltip from 'v-tooltip';

Vue.mixin({
    methods: {
        app_name() { return this.$page.props.config.app_name },
        /**
         * usage this.asset("aaa") OR asset("/aaa")
         * @param {string} resolveURI 
         */
        asset: function (resolveURI) {
            const asset_base = this.$page.props.config.asset_url;
            return (asset_base.slice(asset_base.length - 1) == '/' ? asset_base : asset_base + '/') + (resolveURI.charAt(0) == '/' ? resolveURI.slice(1) : resolveURI);
        },
        // alerts
        /**
         * Accepting title as second argument for backward compatibility
         * 
         * use this.notify(title, message = null, type = null) OR notify(options)
         * 
         * for full customization use this.$root.$emit('notify', options) OR window.$notify(options)
         */
        success_alert(message, title = "Success") {
            this.$root.$emit('notify', {
                type: 'success',
                icon: 'fa-check-circle',
                title: title,
                message: message
            });
        },
        error_alert(message, title = "Error") {
            this.$root.$emit('notify', {
                type: 'error',
                icon: 'fa-times-circle',
                title: title,
                message: message
            });
        },
        info_alert(message, title = "Info") {
            this.$root.$emit('notify', {
                type: 'info',
                icon: 'fa-info-circle',
                title: title,
                message: message
            });
        },
        notify(title, message = '', type = 'info') {
            let options = {
                type: type,
                message: message
            };

            if (typeof title === 'object') {
                options = {
                    ...options,
                    ...title
                };
            } else {
                options.title = title;
            }

            if (!options.icon) {
                switch (options.type) {
                    case 'success':
                        options.icon = 'fa-check-circle';
                        break;
                    case 'error':
                        options.icon = 'fa-times-circle';
                        break;
                    case 'info':
                        options.icon = 'fa-info-circle';
                        break;
                    default:
                        options.icon = 'fa-bell';
                        break;
                }
            }

            this.$root.$emit('notify', options);
        },
        truncateText: (text, limit = 200, after = '...') => {
            let str = text.replace(/(<([^>]+)>)/gi, ""); // strip html tags
            str = str.trim();
            return str.length > limit ? str.substr(0, limit) + after : str;
        },
        currencyFormat(amt) {
            return amt.toLocaleString('en-US', {
                maximumFractionDigits: 2,
                style: 'currency',
                currency: this.$page.props.config.currency
            });
        },
        strip_tags: (str) => str.replace(/(<([^>]+)>)/gi, ""),
        Pluralize: (word, amount) => (amount > 1 || amount == 0) ? `${word}s` : word,
        uuid: () => 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        })
        ,
        PageTitle(title) {
            const appName = this.$page.props.config.app_name || '';
            document.title = title ? `${title} | ${appName}` : appName;
        },
        dateFormat: (timestamp) => {
            if (!timestamp) return '';
            let d = new Date(Date.parse(timestamp));
            let ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
            let mo = new Intl.DateTimeFormat('en', { month: 'short' }).format(d);
            let da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);

            return `${da} ${mo}, ${ye}`;
        },
        dateTimeFormat: (timestamp, showSeconds = true) => {
            let d = new Date(Date.parse(timestamp));
            let ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
            let mo = new Intl.DateTimeFormat('en', { month: 'short' }).format(d);
            let da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);

            let time = new Intl.DateTimeFormat('en', {
                hour12: true,
                hour: 'numeric',
                minute: 'numeric',
                second: showSeconds ? 'numeric' : undefined
            }).format(d);
            return `${da} ${mo}, ${ye} ${time}`;
        },

        getObjLength(obj) {
            return Object.keys(obj).length;
        },

        dateToInputFormat(date) {
            return `${date.getFullYear()}-${("0" + (date.getMonth() + 1)).slice(
                -2
            )}-${("0" + date.getDate()).slice(-2)}`;
        },

        seoTagsToArr(tags) {
            if (!tags) return [];

            return tags
                .split(",")
                .map((item) => {
                    if (item.includes("#")) return item.replace("#", "");

                    item = item.trim().toLowerCase();

                    // remove all non-alphanumeric characters with spaces
                    item = item.replace(/[^a-z0-9\s]/gi, " ");

                    // replace all multiple spaces with single space
                    item = item.replace(/\s+/gi, " ").trim();

                    // replace all spaces with _
                    item = item.replace(/\s/gi, "_");

                    return item;
                })
                .filter((item) => item && item.length > 0);
        }
    },
});

Vue.filter('pluralize', (word, amount) => (amount > 1 || amount == 0) ? `${word}s` : word);

// tooltip
Vue.use(VTooltip);